"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../index.scss");
const Dropdown_1 = __importDefault(require("@Components/Selectors/Dropdown"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const removers_1 = require("@App/helpers/work-entities/removers");
const contexts_1 = require("@App/contexts");
class WriterCardEditable extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "roleCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.data.roleCode
        });
        Object.defineProperty(this, "getCurrentRole", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                this.roleCode = +data.id;
                this.setWriterToDraft();
            }
        });
        Object.defineProperty(this, "setWriterToDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const workDraftFromLocal = this.context.workStore.workDraftLocal;
                const editingWriterId = this.props.data.localId;
                if (!workDraftFromLocal || !editingWriterId) {
                    return;
                }
                const writers = workDraftFromLocal.writers;
                const indexOfWriter = writers.map((writer) => writer.localId).indexOf(editingWriterId);
                const updatedWriter = {
                    id: this.props.data.id,
                    ipId: this.props.data.ipId,
                    localId: this.props.data.localId,
                    firstName: this.props.data.firstName,
                    lastName: this.props.data.lastName, // REQUIRED FIELD
                    ipiNumber: this.props.data.ipiNumber,
                    roleCode: this.roleCode,
                    writerShare: null, // TODO Hard code, not mvp
                };
                const updatedWritersArray = (0, removers_1.setItemToArrayByIndex)(writers, +indexOfWriter, updatedWriter);
                const updatedOP = workDraftFromLocal.originalPublishers.map((op) => {
                    const updatedWr = op.writers.map((writer) => {
                        if (writer.localId === updatedWriter.localId) {
                            return Object.assign(Object.assign({}, writer), { roleCode: updatedWriter.roleCode });
                        }
                        else {
                            return writer;
                        }
                    });
                    return Object.assign(Object.assign({}, op), { writers: updatedWr });
                });
                const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { writers: updatedWritersArray, originalPublishers: updatedOP });
                this.context.workStore.setWorkDraftToLocal(updatedWorkDraft);
            }
        });
        Object.defineProperty(this, "stepValidator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const isValid = !!this.roleCode;
                this.context.workStore.setWizardStepValidation(isValid);
            }
        });
        (0, mobx_1.makeObservable)(this, {
            roleCode: mobx_1.observable,
            getCurrentRole: mobx_1.action,
            setWriterToDraft: mobx_1.action,
        });
    }
    componentDidUpdate() {
        this.stepValidator();
    }
    componentDidMount() {
        this.setWriterToDraft();
        this.stepValidator();
    }
    render() {
        const writerRoleOptions = this.context.libStore.writerRoles;
        if (!writerRoleOptions) {
            return null;
        }
        const { data, removeFunction } = this.props;
        const classNames = ['writer-card'].join(' ');
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: 'head' },
                react_1.default.createElement("p", { className: 'bold' },
                    react_1.default.createElement("span", null, data.firstName),
                    " ",
                    react_1.default.createElement("span", null, data.lastName)),
                react_1.default.createElement("div", { className: 'controls' }, removeFunction ? (react_1.default.createElement("span", { className: 'small-2 medium', onClick: () => removeFunction(data) }, "Remove")) : null)),
            react_1.default.createElement("div", { className: 'content' },
                react_1.default.createElement("p", { className: 'small' },
                    "IPI: ",
                    react_1.default.createElement("strong", null, data.ipiNumber ? data.ipiNumber : '')),
                react_1.default.createElement("div", { className: "edit-area" },
                    react_1.default.createElement("div", { className: "writer-role-edit" },
                        react_1.default.createElement(Dropdown_1.default, { options: writerRoleOptions, 
                            // placeholder={'Writer role'}
                            label: 'Writer role', mainColor: true, selectedValue: this.roleCode
                                ? writerRoleOptions.find((option) => +option.id === this.roleCode)
                                : null, onSelect: this.getCurrentRole, isSearchable: true, errorMessage: this.roleCode ? this.props.errorMessage : 'Required', required: true }))))));
    }
}
exports.default = (0, mobx_react_1.observer)(WriterCardEditable);
WriterCardEditable.contextType = contexts_1.StoresContext;
